<template>
  <div class="history-overview-wrapper" :class="$vuetify.breakpoint.mdAndUp ? '' : 'ml-0'">
    <!-- Mobile Tab -->
    <v-row v-if="$vuetify.breakpoint.mdAndDown" no-gutters justify="center">
      <v-card class="mobile-history-card betting-history-tab" elevation="0">
        <v-col class="text-center betting-history-tab" cols="12">
          <v-btn class="history-tab-mobile" :color="selectedTab == 'OVERVIEW' ? 'primary' : ''" depressed @click="onChangeTab('OVERVIEW')">
            <v-icon class="mobile-icon white--text">mdi-cached</v-icon>
            <span v-if="selectedTab == 'OVERVIEW'">{{ $t(`label.overview`) }}</span>
          </v-btn>
          <v-btn class="history-tab-mobile" :color="selectedTab == 'SPORTS' ? 'primary' : ''" depressed @click="onChangeTab('SPORTS', 4)">
            <v-icon class="mobile-icon white--text">mdi-soccer</v-icon>
            <span v-if="selectedTab == 'SPORTS'">{{ $t(`label.sports`) }}</span>
          </v-btn>
          <v-btn class="history-tab-mobile" :color="selectedTab == 'LIVE' ? 'primary' : ''" depressed @click="onChangeTab('LIVE', 3)">
            <v-icon class="mobile-icon white--text">mdi-television</v-icon>
            <span v-if="selectedTab == 'LIVE'">{{ $t(`label.live`) }}</span>
          </v-btn>
          <v-btn class="history-tab-mobile" :color="selectedTab == 'SLOTS' ? 'primary' : ''" depressed @click="onChangeTab('SLOTS', 1)">
            <v-icon class="mobile-icon white--text">mdi-slot-machine</v-icon>
            <span v-if="selectedTab == 'SLOTS'">{{ $t(`label.slots`) }}</span>
          </v-btn>
          <v-btn class="history-tab-mobile" :color="selectedTab == 'TABLE' ? 'primary' : ''" depressed @click="onChangeTab('TABLE', 9)">
            <v-icon class="mobile-icon white--text">mdi-checkerboard</v-icon>
            <span v-if="selectedTab == 'TABLE'">{{ $t(`label.table_short`) }}</span>
          </v-btn>
          <v-btn class="history-tab-mobile" :color="selectedTab == 'CRICKET' ? 'primary' : ''" depressed @click="onChangeTab('CRICKET', 10)">
            <v-icon class="mobile-icon white--text">mdi-baseball-bat</v-icon>
            <span v-if="selectedTab == 'CRICKET'">{{ $t(`label.cricket`) }}</span>
          </v-btn>
        </v-col>
      </v-card>
    </v-row>
    <!-- End Mobile Tab -->

    <v-card class="desktop_card betting-history-tab" elevation="0" :class="pagination.last_page > 1 ? 'height-100' : ''">
      <!-- <v-card-title class="justify-space-between" v-if="$vuetify.breakpoint.mdAndUp">
        <label class="--v-primary-base text-left">{{ $t(`label.playerHistory`) }}</label>
      </v-card-title> -->
      <!-- Desktop Tab -->
      <v-row v-if="$vuetify.breakpoint.lgAndUp" no-gutters justify="start" class="px-3 py-3">
        <v-col class="player-history-container-desktop text-start pb-2" cols="12">
          <v-btn class="player-history-tab" :color="selectedTab == 'OVERVIEW' ? 'primary' : ''" depressed @click="onChangeTab('OVERVIEW')">
            {{ $t(`label.overview`) }}
          </v-btn>
          <v-btn class="player-history-tab" :color="selectedTab == 'SPORTS' ? 'primary' : ''" depressed @click="onChangeTab('SPORTS', 4)">
            {{ $t(`label.sports`) }}
          </v-btn>
          <v-btn class="player-history-tab" :color="selectedTab == 'LIVE' ? 'primary' : ''" depressed @click="onChangeTab('LIVE', 3)">
            {{ $t(`label.live`) }}
          </v-btn>
          <v-btn class="player-history-tab" :color="selectedTab == 'SLOTS' ? 'primary' : ''" depressed @click="onChangeTab('SLOTS', 1)">
            {{ $t(`label.slots`) }}
          </v-btn>
          <v-btn class="player-history-tab" :color="selectedTab == 'TABLE' ? 'primary' : ''" depressed @click="onChangeTab('TABLE', 9)">
            {{ $t(`label.table_short`) }}
          </v-btn>
          <v-btn class="player-history-tab" :color="selectedTab == 'CRICKET' ? 'primary' : ''" depressed @click="onChangeTab('CRICKET', 10)">
            {{ $t(`label.cricket`) }}
          </v-btn>
        </v-col>
      </v-row>
      <!-- End Desktop Tab -->
      <v-card class="history-card" elevation="0">
        <!-- Desktop -->
        <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp">
          <!-- Overview -->
          <v-col cols="12" v-if="selectedTab == 'OVERVIEW'">
            <v-data-table :headers="overviewHeaders" :items="historyList" class="elevation-0 background-transparent pb-1" :hide-default-footer="true" hide-default-header :items-per-page="-1">
              <template v-slot:header="{ props }">
                <tr>
                  <th class="referral-table-header text-start table-desktop-header-padding" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                      <span v-if="head.sortable">
                        <v-icon v-if="head.sortBy == 'asc'" @click="sortTableList(head)">mdi-chevron-down</v-icon>
                        <v-icon v-if="head.sortBy == 'desc'" @click="sortTableList(head)">mdi-chevron-up</v-icon>
                      </span>
                    </span>
                  </th>
                </tr>
              </template>
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-start table-desktop-column">
                    {{ item.bet_date | longDate }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.bet_count }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.total_bet_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.total_win_loss | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.total_jackpot_contribution | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.total_jackpot_win | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column"></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- End Overview -->

          <!-- Sports -->
          <v-col cols="12" v-if="selectedTab == 'SPORTS'">
            <v-row no-gutters class="pa-3" align="center table-desktop-header-padding">
              <v-col cols="3" class="provider-padding">
                <v-select
                  :label="$t(`label.provider`)"
                  customClass="provider-select"
                  type="select"
                  class="date-search white--text provider-selection-desktop elevation-0"
                  :items="sportsProviderDdl"
                  v-model.trim="historyProvider"
                  :clearable="true"
                  :displayText="this.sportsProviderDdlText"
                  @input="filterListByProvider()"
                ></v-select>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-col cols="12" class="text-center pr-2 pa-0">
                    <label class="referral-table-header subtitle-1 white--text">{{ $t(`label.totalBetAmount`) }} {{ count.total_bet_amount | currency(currentCurrency) }}</label>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      outlined
                      class="date-search ml-3 elevation-0 text-center"
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-data-table :headers="detailHeaders" :items="historyList" class="elevation-0 background-transparent pb-1" :hide-default-footer="true" hide-default-header :items-per-page="-1">
              <template v-slot:header="{ props }">
                <tr>
                  <th class="referral-table-header text-start table-desktop-header-padding" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                      <span v-if="head.sortable">
                        <v-icon v-if="head.sortBy == 'asc'" @click="sortTableList(head)">mdi-chevron-down</v-icon>
                        <v-icon v-if="head.sortBy == 'desc'" @click="sortTableList(head)">mdi-chevron-up</v-icon>
                      </span>
                    </span>
                  </th>
                </tr>
              </template>
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-start table-desktop-column">
                    {{ item.bet_time | longDate }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.winloss_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.vendor_bet_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.provider }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.game_name }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ convertNan() | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column"></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- End Sports -->

          <!-- Live -->
          <v-col cols="12" v-if="selectedTab == 'LIVE'">
            <v-row no-gutters class="pa-3" align="center table-desktop-header-padding">
              <v-col cols="3" class="provider-padding">
                <v-select
                  :label="$t(`label.provider`)"
                  customClass="provider-select"
                  type="select"
                  class="date-search white--text provider-selection-desktop elevation-0"
                  :items="liveProviderDdl"
                  v-model.trim="historyProvider"
                  :clearable="true"
                  :displayText="this.liveProviderDdlText"
                  @input="filterListByProvider()"
                ></v-select>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-col cols="12" class="text-center pr-2">
                    <label class="referral-table-header subtitle-1 white--text">{{ $t(`label.totalBetAmount`) }} {{ count.total_bet_amount | currency(currentCurrency) }}</label>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      outlined
                      class="date-search ml-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-data-table :headers="detailHeaders" :items="historyList" class="elevation-0 background-transparent pb-1" :hide-default-footer="true" hide-default-header :items-per-page="-1">
              <template v-slot:header="{ props }">
                <tr>
                  <th class="referral-table-header text-start table-desktop-header-padding" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                      <span v-if="head.sortable">
                        <v-icon v-if="head.sortBy == 'asc'" @click="sortTableList(head)">mdi-chevron-down</v-icon>
                        <v-icon v-if="head.sortBy == 'desc'" @click="sortTableList(head)">mdi-chevron-up</v-icon>
                      </span>
                    </span>
                  </th>
                </tr>
              </template>
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-start table-desktop-column">
                    {{ item.bet_time | longDate }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.winloss_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.vendor_bet_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.provider }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.game_name }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ convertNan() | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column"></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- End Live -->

          <!-- Slots -->
          <v-col cols="12" v-if="selectedTab == 'SLOTS'">
            <v-row no-gutters class="pa-3" align="center table-desktop-header-padding">
              <v-col cols="3" class="provider-padding">
                <v-select
                  :label="$t(`label.provider`)"
                  customClass="provider-select"
                  type="select"
                  :items="slotsProviderDdl"
                  v-model.trim="historyProvider"
                  class="date-search white--text provider-selection-desktop elevation-0"
                  :clearable="true"
                  :displayText="this.slotsProviderDdlText"
                  @input="filterListByProvider()"
                ></v-select>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-col cols="12" class="text-center pr-2">
                    <label class="referral-table-header subtitle-1 white--text">{{ $t(`label.totalBetAmount`) }} {{ count.total_bet_amount | currency(currentCurrency) }}</label>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      outlined
                      class="date-search ml-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-data-table :headers="detailHeaders" :items="historyList" class="elevation-0 background-transparent pb-1" :hide-default-footer="true" hide-default-header :items-per-page="-1">
              <template v-slot:header="{ props }">
                <tr>
                  <th class="referral-table-header text-start table-desktop-header-padding" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                      <span v-if="head.sortable">
                        <v-icon v-if="head.sortBy == 'asc'" @click="sortTableList(head)">mdi-chevron-down</v-icon>
                        <v-icon v-if="head.sortBy == 'desc'" @click="sortTableList(head)">mdi-chevron-up</v-icon>
                      </span>
                    </span>
                  </th>
                </tr>
              </template>
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-start table-desktop-column">
                    {{ item.bet_time | longDate }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.winloss_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.vendor_bet_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.provider }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.game_name }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ convertNan() | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column"></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- End Slots -->

          <!-- Table -->
          <v-col cols="12" v-if="selectedTab == 'TABLE'">
            <v-row no-gutters class="pa-3" align="center table-desktop-header-padding">
              <v-col cols="3" class="provider-padding">
                <v-select
                  :label="$t(`label.provider`)"
                  :hint="$t(`label.provider`)"
                  customClass="provider-select"
                  type="select"
                  :items="tableProviderDdl"
                  v-model.trim="historyProvider"
                  class="date-search white--text provider-selection-desktop elevation-0"
                  :clearable="true"
                  :displayText="this.tableProviderDdlText"
                  @input="filterListByProvider()"
                ></v-select>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-col cols="12" class="text-center pr-2">
                    <label class="referral-table-header subtitle-1 white--text">{{ $t(`label.totalBetAmount`) }} {{ count.total_bet_amount | currency(currentCurrency) }}</label>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      outlined
                      class="date-search ml-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-data-table :headers="detailHeaders" :items="historyList" class="elevation-0 background-transparent pb-1" :hide-default-footer="true" hide-default-header :items-per-page="-1">
              <template v-slot:header="{ props }">
                <tr>
                  <th class="referral-table-header text-start table-desktop-header-padding" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                      <span v-if="head.sortable">
                        <v-icon v-if="head.sortBy == 'asc'" @click="sortTableList(head)">mdi-chevron-down</v-icon>
                        <v-icon v-if="head.sortBy == 'desc'" @click="sortTableList(head)">mdi-chevron-up</v-icon>
                      </span>
                    </span>
                  </th>
                </tr>
              </template>
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-start table-desktop-column">
                    {{ item.bet_time | longDate }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.winloss_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.vendor_bet_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.provider }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.game_name }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ convertNan() | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column"></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- End Table -->

          <!-- Cricket -->
          <v-col cols="12" v-if="selectedTab == 'CRICKET'">
            <v-row no-gutters class="pa-3" align="center table-desktop-header-padding">
              <v-col cols="3" class="provider-padding">
                <v-select
                  :label="$t(`label.provider`)"
                  :hint="$t(`label.provider`)"
                  customClass="provider-select"
                  type="select"
                  :items="cricketProviderDdl"
                  v-model.trim="historyProvider"
                  class="date-search white--text provider-selection-desktop elevation-0"
                  :clearable="true"
                  :displayText="this.cricketProviderDdlText"
                  @input="filterListByProvider()"
                ></v-select>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-col cols="12" class="text-center pr-2">
                    <label class="referral-table-header subtitle-1 white--text">{{ $t(`label.totalBetAmount`) }} {{ count.total_bet_amount | currency(currentCurrency) }}</label>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      outlined
                      class="date-search ml-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-data-table :headers="detailHeaders" :items="historyList" class="elevation-0 background-transparent pb-1" :hide-default-footer="true" hide-default-header :items-per-page="-1">
              <template v-slot:header="{ props }">
                <tr>
                  <th class="referral-table-header text-start table-desktop-header-padding" v-for="head in props.headers" :key="head.text">
                    <span v-if="head.text !== 'dateSearch'">
                      {{ $t(`label.${head.text}`) }}
                      <span v-if="head.sortable">
                        <v-icon v-if="head.sortBy == 'asc'" @click="sortTableList(head)">mdi-chevron-down</v-icon>
                        <v-icon v-if="head.sortBy == 'desc'" @click="sortTableList(head)">mdi-chevron-up</v-icon>
                      </span>
                    </span>
                  </th>
                </tr>
              </template>
              <template v-slot:body="{ items }">
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-start table-desktop-column">
                    {{ item.bet_time | longDate }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.winloss_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.vendor_bet_id }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.provider }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.game_name }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ convertNan() | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </td>
                  <td class="text-start table-desktop-column"></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
          <!-- End Cricket -->
        </v-row>
        <!-- End Desktop -->

        <!-- Mobile -->
        <v-row no-gutters v-else>
          <!-- Mobile Overview -->
          <v-col cols="12" v-if="this.selectedTab == 'OVERVIEW'">
            <v-row v-for="(item, index) in historyList" :key="index" class="mobile-history-table">
              <v-col cols="6" class="mr-0">
                <v-row no-gutters class="referral-table-header pl-6">
                  <v-col cols="12" v-for="h in overviewHeaders" :key="h.text">
                    {{ $t(`label.${h.text}`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    {{ item.bet_date | longDate }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.bet_count }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.total_bet_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.total_win_loss | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.total_jackpot_contribution | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.total_jackpot_win | currency(currentCurrency) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <!-- End Mobile Overview -->

          <!-- Mobile Sports -->
          <v-col cols="12" v-if="this.selectedTab == 'SPORTS'">
            <v-row>
              <!-- Mobile date picker -->
              <v-col cols="12" class="pt-4 pb-2 px-4 date-padding">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      color="buttonPrimary"
                      outlined
                      class="date-search-mobile mb-3 elevation-0  text-center"
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
              <!-- End Mobile date picker -->

              <!-- Mobile Provider -->
              <v-col cols="12" class="pt-4 pb-2 px-4 mobile-provider-padding">
                <template>
                  <app-form-field
                    :label="$t(`label.provider`)"
                    :hint="$t(`label.provider`)"
                    customClass="mobile-provider-select"
                    type="select"
                    :items="sportsProviderDdl"
                    v-model.trim="historyProvider"
                    class="date-search-mobile mb-3 elevation-0 v-label"
                    :clearable="true"
                    :displayText="this.sportsProviderDdlText"
                    @input="filterListByProvider()"
                  ></app-form-field>
                </template>
              </v-col>
              <!-- End Mobile Provider -->
            </v-row>
            <v-row v-for="(item, index) in historyList" :key="index" class="mobile-history-table">
              <v-col cols="6" class="mr-0">
                <v-row no-gutters class="referral-table-header pl-6">
                  <v-col cols="12" v-for="h in detailHeaders" :key="h.text">
                    {{ $t(`label.${h.text}`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    {{ item.bet_time | longDate }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.winloss_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.vendor_bet_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.provider }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.game_name }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ convertNan() | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <!-- End Mobile Sports -->

          <!-- Mobile Live -->
          <v-col cols="12" v-if="this.selectedTab == 'LIVE'">
            <v-row>
              <!-- Mobile date picker -->
              <v-col cols="12" class="pt-4 pb-2 px-4 date-padding">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      color="buttonPrimary"
                      outlined
                      class="date-search-mobile mb-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
              <!-- End Mobile date picker -->

              <!-- Mobile Provider -->
              <v-col cols="12" class="pt-4 pb-2 px-4 mobile-provider-padding">
                <template>
                  <app-form-field
                    :label="$t(`label.provider`)"
                    :hint="$t(`label.provider`)"
                    customClass="mobile-provider-select"
                    type="select"
                    :items="liveProviderDdl"
                    v-model.trim="historyProvider"
                    class="date-search-mobile mb-3 elevation-0"
                    :clearable="true"
                    :displayText="this.liveProviderDdlText"
                    @input="filterListByProvider()"
                  ></app-form-field>
                </template>
              </v-col>
              <!-- End Mobile Provider -->
            </v-row>
            <v-row v-for="(item, index) in historyList" :key="index" class="mobile-history-table">
              <v-col cols="6" class="mr-0">
                <v-row no-gutters class="referral-table-header pl-6">
                  <v-col cols="12" v-for="h in detailHeaders" :key="h.text">
                    {{ $t(`label.${h.text}`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    {{ item.bet_time | longDate }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.winloss_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.vendor_bet_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.provider }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.game_name }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ convertNan() | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <!-- End Mobile Live -->

          <!-- Mobile Slots -->
          <v-col cols="12" v-if="this.selectedTab == 'SLOTS'">
            <v-row>
              <!-- Mobile date picker -->
              <v-col cols="12" class="pt-4 pb-2 px-4 date-padding">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      color="buttonPrimary"
                      outlined
                      class="date-search-mobile mb-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
              <!-- End Mobile date picker -->

              <!-- Mobile Provider -->
              <v-col cols="12" class="pt-4 pb-2 px-4 mobile-provider-padding">
                <template>
                  <app-form-field
                    :label="$t(`label.provider`)"
                    :hint="$t(`label.provider`)"
                    customClass="mobile-provider-select"
                    type="select"
                    :items="slotsProviderDdl"
                    v-model.trim="historyProvider"
                    class="date-search-mobile mb-3 elevation-0"
                    :clearable="true"
                    :displayText="this.slotsProviderDdlText"
                    @input="filterListByProvider()"
                  ></app-form-field>
                </template>
              </v-col>
              <!-- End Mobile Provider -->
            </v-row>
            <v-row v-for="(item, index) in historyList" :key="index" class="mobile-history-table">
              <v-col cols="6" class="mr-0">
                <v-row no-gutters class="referral-table-header pl-6">
                  <v-col cols="12" v-for="h in detailHeaders" :key="h.text">
                    {{ $t(`label.${h.text}`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    {{ item.bet_time | longDate }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.winloss_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.vendor_bet_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.provider }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.game_name }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ convertNan() | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <!-- End Mobile Slots -->

          <!-- Mobile Animal -->
          <v-col cols="12" v-if="this.selectedTab == 'TABLE'">
            <v-row>
              <!-- Mobile date picker -->
              <v-col cols="12" class="pt-4 pb-2 px-4 date-padding">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      color="buttonPrimary"
                      outlined
                      class="date-search-mobile mb-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
              <!-- End Mobile date picker -->

              <!-- Mobile Provider -->
              <v-col cols="12" class="pt-4 pb-2 px-4 mobile-provider-padding">
                <template>
                  <app-form-field
                    :label="$t(`label.provider`)"
                    :hint="$t(`label.provider`)"
                    customClass="mobile-provider-select"
                    type="select"
                    :items="tableProviderDdl"
                    v-model.trim="historyProvider"
                    class="date-search-mobile mb-3 elevation-0"
                    :clearable="true"
                    :displayText="this.tableProviderDdlText"
                    @input="filterListByProvider()"
                  ></app-form-field>
                </template>
              </v-col>
              <!-- End Mobile Provider -->
            </v-row>
            <v-row v-for="(item, index) in historyList" :key="index" class="mobile-history-table">
              <v-col cols="6" class="mr-0">
                <v-row no-gutters class="referral-table-header pl-6">
                  <v-col cols="12" v-for="h in detailHeaders" :key="h.text">
                    {{ $t(`label.${h.text}`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    {{ item.bet_time | longDate }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.winloss_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.vendor_bet_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.provider }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.game_name }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ convertNan() | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <!-- End Mobile Animal -->

          <!-- Mobile Chess -->
          <v-col cols="12" v-if="this.selectedTab == 'CRICKET'">
            <v-row>
              <!-- Mobile date picker -->
              <v-col cols="12" class="pt-4 pb-2 px-4 date-padding">
                <v-menu ref="menu" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      color="buttonPrimary"
                      outlined
                      class="date-search-mobile mb-3 elevation-0 "
                      hide-details="true"
                      v-on="on"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="buttonPrimary" no-title v-model="dates" :max="defaultDate" :min="oneMonthDate" @input="selectedDate()"></v-date-picker>
                </v-menu>
              </v-col>
              <!-- End Mobile date picker -->

              <!-- Mobile Provider -->
              <v-col cols="12" class="pt-4 pb-2 px-4 mobile-provider-padding">
                <template>
                  <app-form-field
                    :label="$t(`label.provider`)"
                    :hint="$t(`label.provider`)"
                    customClass="mobile-provider-select"
                    type="select"
                    :items="cricketProviderDdl"
                    v-model.trim="historyProvider"
                    class="date-search-mobile mb-3 elevation-0"
                    :clearable="true"
                    :displayText="this.cricketProviderDdlText"
                    @input="filterListByProvider()"
                  ></app-form-field>
                </template>
              </v-col>
              <!-- End Mobile Provider -->
            </v-row>
            <v-row v-for="(item, index) in historyList" :key="index" class="mobile-history-table">
              <v-col cols="6" class="mr-0">
                <v-row no-gutters class="referral-table-header pl-6">
                  <v-col cols="12" v-for="h in detailHeaders" :key="h.text">
                    {{ $t(`label.${h.text}`) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    {{ item.bet_time | longDate }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.winloss_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.vendor_bet_id }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.provider }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.game_name }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.bet_amount | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.valid_bets | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.win_loss | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ convertNan() | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_contribution | currency(currentCurrency) }}
                  </v-col>
                  <v-col cols="12">
                    {{ item.jackpot_win | currency(currentCurrency) }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mx-2"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <!-- End Mobile Animal -->
        </v-row>
        <!-- End Mobile -->
        <v-row no-gutters>
          <v-col cols="12" v-if="historyList.length == 0" class="text-center pt-5 pb-8">
            <label class="referral-table-header subtitle-2">{{ $t(`message.noDataAvaliable`) }}</label>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-1" v-if="pagination.last_page > 1">
          <v-col cols="12" class="text-center">
            <v-pagination
              class="trxn_history_pagination"
              v-model="pagination.current_page"
              :length="pagination.last_page"
              @input="changePage"
              :next-icon="'mdi-chevron-right'"
              :prev-icon="'mdi-chevron-left'"
              :total-visible="10"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { uiHelper, locale, formValidator, ddlHandler } from '@/util'
import { SHARED } from '@/constants/constants'
import cloneDeep from 'lodash/cloneDeep'
import filter from 'lodash/filter'
import find from 'lodash/find'
import map from 'lodash/map'
import orderBy from 'lodash/orderBy'
import { HISTORY_OVERVIEW, HISTORY_DETAIL } from '@/store/history.module'

export default {
  name: 'playerHistory',
  data: function() {
    return {
      dateMenu: false,
      selectMenu: false,
      dates: SHARED.DEFAULT_DATE,
      oneMonthDate: SHARED.DEFAULT_SEVEN_DAYS,
      defaultDate: SHARED.DEFAULT_DATE,
      language: uiHelper.getLanguage(),
      currentCurrency: uiHelper.getCurrency(),
      validator: formValidator,
      shared: SHARED,
      selectedTab: 'OVERVIEW',
      historyProvider: '',
      historyGameType: 1,
      slotsProviderDdl: ddlHandler.getSlotsProvider(),
      sportsProviderDdl: ddlHandler.getSportsProvider(),
      liveProviderDdl: ddlHandler.getLiveProvider(),
      tableProviderDdl: ddlHandler.getTableProvider(),
      cricketProviderDdl: ddlHandler.getCricketProvider(),
      selectedList: [],
      pagination: {
        currentPage: 1,
        totalPage: 1,
        paginationPageLimit: 10
      },
      historyDetail: {
        data: [
          {
            tip: 0
          }
        ]
      },
      searchCriteria: {
        pageNumber: 1,
        pageSize: 20,
        mobilePageSize: 10
      },
      overviewHeaders: [
        {
          text: 'date',
          align: 'start',
          sortable: true,
          value: 'bet_date',
          sortBy: 'desc'
        },
        {
          text: 'betCount',
          value: 'bet_count',
          sortable: false
        },
        {
          text: 'betAmount',
          value: 'total_bet_amount',
          sortable: false
        },
        {
          text: 'winLoss',
          value: 'total_win_loss',
          sortable: false
        },
        {
          text: 'jackpotContribution',
          value: 'total_jackpot_contribution',
          sortable: false
        },
        {
          text: 'jackpotAmount',
          value: 'total_jackpot_win',
          sortable: false
        }
      ],
      detailHeaders: [
        {
          text: 'date',
          align: 'start',
          sortable: true,
          value: 'bet_time',
          sortBy: 'desc'
        },
        {
          text: 'winLossId',
          value: 'winloss_id',
          sortable: false
        },
        {
          text: 'vendorBetId',
          value: 'vendor_bet_id',
          sortable: false
        },
        {
          text: 'provider',
          value: 'provider',
          sortable: false
        },
        {
          text: 'historyGameName',
          value: 'game_name',
          sortable: false
        },
        {
          text: 'betAmount',
          value: 'bet_amount',
          sortable: false
        },
        {
          text: 'validBet',
          value: 'valid_bets',
          sortable: false
        },
        {
          text: 'historyWinLoss',
          value: 'win_loss',
          sortable: false
        },
        {
          text: 'tip',
          value: 'tip',
          sortable: false
        },
        {
          text: 'jackpotContribution',
          value: 'jackpot_contribution',
          sortable: false
        },
        {
          text: 'jackpotAmount',
          value: 'jackpot_win',
          sortable: false
        }
      ],
      historyList: [],
      providerDdlList: [],
      selectedPage: 1
    }
  },
  created() {
    this.metaTag()
    this.getOverviewHistory(this.selectedTab)
    this.getDetailHistory()
  },
  computed: {
    dateRangeText: {
      get() {
        let startDate = this.dates ? this.dates : SHARED.DEFAULT_DATE
        let endDate = this.dates ? this.dates : SHARED.DEFAULT_DATE
        return startDate
      },
      set(dateRange) {
        this.dates = []
      }
    },
    overviewHistory() {
      return this.$store.state.history.historyOverview.data
    },
    overviewHistoryPagination() {
      return this.$store.state.history.historyOverview.pagination
    },
    detailHistory() {
      return this.$store.state.history.historyDetail.data
    },
    detailHistoryPagination() {
      return this.$store.state.history.historyDetail.pagination
    },
    count() {
      return this.$store.state.history.historyDetail.count
    }
  },
  watch: {
    overviewHistory() {
      this.getTransactionList()
    },
    detailHistory() {
      this.getTransactionList()
    }
  },
  methods: {
    metaTag() {
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    selectedDate() {
      if (this.dates[0] && this.dates[1]) {
        let self = this
        setTimeout(function() {
          self.dateMenu = false
        }, 500)
      }
    },
    changePage(targetPage) {
      this.selectedPage = targetPage
      if (this.selectedTab == 'OVERVIEW') {
        this.getOverviewHistory()
      } else if (this.selectedTab == 'SPORTS') {
        this.getDetailHistory(this.selectedTab)
      } else if (this.selectedTab == 'LIVE') {
        this.getDetailHistory(this.selectedTab)
      } else if (this.selectedTab == 'SLOTS') {
        this.getDetailHistory(this.selectedTab)
      } else if (this.selectedTab == 'TABLE') {
        this.getDetailHistory(this.selectedTab)
      } else if (this.selectedTab == 'CRICKET') {
        this.getDetailHistory(this.selectedTab)
      }
    },
    onChangeTab(type, gameType, filterDate, filterProvider) {
      this.historyList = []
      this.selectedTab = type
      this.historyGameType = gameType
      if (!filterDate) {
        this.dates = SHARED.DEFAULT_DATE
      }
      if (!filterProvider) {
        this.historyProvider = ''
      }
      this.selectedPage = 1
      if (this.selectedTab == 'OVERVIEW') {
        this.getOverviewHistory(type)
      } else if (this.selectedTab == 'SPORTS') {
        this.getDetailHistory(type, gameType)
      } else if (this.selectedTab == 'LIVE') {
        this.getDetailHistory(type, gameType)
      } else if (this.selectedTab == 'SLOTS') {
        this.getDetailHistory(type, gameType)
      } else if (this.selectedTab == 'TABLE') {
        this.getDetailHistory(type, gameType)
      } else if (this.selectedTab == 'CRICKET') {
        this.getDetailHistory(type, gameType)
      }
    },
    getOverviewHistory() {
      let playerHistoryOverviewObj = {
        page: this.selectedPage,
        itemsPerPage: 10
      }
      this.$store.dispatch(`${HISTORY_OVERVIEW}`, {
        playerHistoryOverviewObj
      })
    },
    getDetailHistory() {
      let playerHistoryDetailObj = {
        startDate: this.dates + ' 00:00:00',
        endDate: this.dates + ' 23:59:59',
        page: this.selectedPage,
        provider: this.historyProvider,
        gameType: this.historyGameType,
        itemsPerPage: 10
      }
      this.$store.dispatch(`${HISTORY_DETAIL}`, {
        playerHistoryDetailObj
      })
    },
    getTransactionList() {
      if (this.selectedTab == 'OVERVIEW') {
        this.historyList = cloneDeep(this.overviewHistory)
        this.pagination = this.overviewHistoryPagination
      } else if (this.selectedTab == 'SPORTS') {
        this.historyList = cloneDeep(this.detailHistory)
        this.pagination = this.detailHistoryPagination
      } else if (this.selectedTab == 'LIVE') {
        this.historyList = cloneDeep(this.detailHistory)
        this.pagination = this.detailHistoryPagination
      } else if (this.selectedTab == 'SLOTS') {
        this.historyList = cloneDeep(this.detailHistory)
        this.pagination = this.detailHistoryPagination
      } else if (this.selectedTab == 'TABLE') {
        this.historyList = cloneDeep(this.detailHistory)
        this.pagination = this.detailHistoryPagination
      } else if (this.selectedTab == 'CRICKET') {
        this.historyList = cloneDeep(this.detailHistory)
        this.pagination = this.detailHistoryPagination
      }
    },
    clearFilter() {
      this.dates = []
      this.onChangeTab(this.selectedTab)
    },
    filterListByDate() {
      this.onChangeTab(this.selectedTab, this.historyGameType, true)
    },
    filterListByProvider() {
      this.onChangeTab(this.selectedTab, this.historyGameType, true, true)
    },
    sortTableList(obj) {
      let headers = []
      if (this.selectedTab == 'OVERVIEW') {
        headers = this.overviewHeaders
      } else if (this.selectedTab == 'SPORTS') {
        headers = this.detailHeaders
      } else if (this.selectedTab == 'LIVE') {
        headers = this.detailHeaders
      } else if (this.selectedTab == 'SLOTS') {
        headers = this.detailHeaders
      } else if (this.selectedTab == 'TABLE') {
        headers = this.detailHeaders
      } else if (this.selectedTab == 'CRICKEt') {
        headers = this.detailHeaders
      }
      let sortBy = filter(headers, function(d) {
        return d.sortable
      })
      if (obj) {
        let selected = find(sortBy, function(d) {
          if (d.value == obj.value) {
            d.sortBy = d.sortBy == 'asc' ? 'desc' : 'asc'
            return true
          }
        })
      }
      this.historyList = orderBy(this.historyList, map(sortBy, 'value'), map(sortBy, 'sortBy'))
    },
    slotsProviderDdlText(data) {
      let d
      d = locale.getMessage(`enumSlotsProvider[0].${data.value}`)
      return d
    },
    sportsProviderDdlText(data) {
      let d
      d = locale.getMessage(`enumSportsProvider[0].${data.value}`)
      return d
    },
    liveProviderDdlText(data) {
      let d
      d = locale.getMessage(`enumLiveProvider[0].${data.value}`)
      return d
    },
    tableProviderDdlText(data) {
      let d
      d = locale.getMessage(`enumTableProvider[0].${data.value}`)
      return d
    },
    cricketProviderDdlText(data) {
      let d
      d = locale.getMessage(`enumCricketProvider[0].${data.value}`)
      return d
    },
    convertNan() {
      let d
      if (isNaN(this.historyList.tip)) {
        this.historyList.tip = 0
        return this.historyList.tip
      } else {
        d = parseFloat(this.historyList.tip).toFixed(2)
        return d
      }
    }
  }
}
</script>

<style lang="scss">
.v-pagination__more {
  color: white;
}
.height-100 {
  height: 100% !important;
}
.table-desktop-header-padding {
  padding: 10px 16px;
}
.table-desktop-column {
  color: white;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  padding: 10px 16px;
}
.provider-selection-desktop {
  background: #322c44;
  border: thin solid #413275;
  margin: 0px;
  padding-top: 0px;
  .v-text-field__details {
    min-height: 0px !important;
    height: 0px;
  }
  .v-select__slot {
    .v-label {
      padding-left: 10px;
      top: 7px !important;
      color: white !important;
    }
    padding-left: 10px;
  }
  .v-input__slot {
    margin-bottom: 0px !important;
  }
}
.background-transparent {
  background: transparent;
}
.date-search-mobile .v-icon {
  color: white !important;
}
.player-history-container-desktop {
  display: flex;
  overflow: auto !important;
  padding-bottom: 10px;
}
.player-history-container-desktop {
  -ms-overflow-style: none; /* Hide IE scrollbar */
}

.player-history-container-desktop::-webkit-scrollbar {
  height: 8px; /* Adjust height for horizontal scrollbar */
}

.player-history-container-desktop::-webkit-scrollbar-thumb {
  background-color: #ffc000 !important;
  border-radius: 10px !important;
}

.player-history-container-desktop::-webkit-scrollbar-track {
  background: #3d3360; /* Track color */
  border-radius: 10px;
}
.betting-history-tab {
  background: transparent linear-gradient(134deg, #3d3360 0%, #0f0a20 100%) 0 0 no-repeat padding-box !important;
  border-radius: 0 !important;
}
.history-overview-wrapper {
  max-width: 1240px;
  margin: auto;
}

.trxn_history_pagination .v-pagination {
  li {
    border: none !important;

    button {
      border: none !important;
      font-size: 14px;
    }
  }
}

.mobile-history-table {
  .col-12 {
    min-height: 20px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: auto;
    white-space: nowrap;
  }
}

.history-card {
  height: 100%;
  overflow: auto;
  background: transparent !important;

  .date-search {
    width: fit-content;
    margin-right: 0px;
    float: right !important;

    .v-input__slot {
      min-height: 40px !important;
      max-width: 250px;
    }

    .v-input__append-inner {
      margin-top: 8px;
    }
  }

  .referral-table-header {
    color: #fff;
  }
}

.date-search-mobile {
  .v-input__slot {
    color: white;
    min-height: 40px !important;
  }

  .v-input__append-inner {
    margin-top: 8px;
  }
}

.mobile-history-card {
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  white-space: nowrap;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.player-history-tab {
  width: 140px;
  margin-right: 15px;
  padding: 10px;
  background-color: #fff;
  text-transform: capitalize;
}

.history-tab-mobile {
  width: fit-content !important;
  margin-right: 5px;
  min-width: fit-content !important;
  padding: 2px;
  background-color: #fff;
  text-transform: capitalize;
  font-size: 12px !important;

  .mobile-icon {
    margin-right: 3px;
    width: 20px;
    height: 20px;
  }

  .mobile-icon-active {
    fill: #3a3a3a !important;

    path {
      fill: #fff !important;
    }
  }
}

.text-start {
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  white-space: nowrap;
}

.text-center {
  margin: auto;
}

.pt-4.pb-2.px-4.mobile-provider-padding.col.col-12 {
  padding-top: 0px !important;
}

.pt-4.pb-2.px-4.date-padding.col.col-12 {
  padding-bottom: 0px !important;
}

.provider-select {
  top: 13px;
}

.mobile-provider-select {
  top: 5px;
}

.mobile-provider-padding .v-input .v-label {
  color: white;
  top: 10px !important;
}
.provider-select .v-input .v-label {
  color: white;
}

//.provider-padding .v-input .v-label {
//  top: 15px !important;
//}

@media (max-width: 959px) {
  .history-card {
    font-size: 12px;
    height: 100%;

    .referral-table-header {
      color: #fff;
    }
  }
}
</style>
